// Modules
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';

// Components
import { SearchDistrictComponent } from './search-district/search-district.component';

import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DistrictEntityService } from '../service/district-entity.service';
import { RegionEntityService } from '../service/region-entity.service';

import { HelperService } from 'src/app/service/helper.service';
import { Region } from 'src/app/model/region.model';

@Component({
    selector: 'app-district',
    templateUrl: './district.component.html',
    styleUrls: ['./district.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistrictComponent implements OnInit {
    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Input('reset') reset: boolean;
    @Input() DistrictCode: number | undefined;
    @ViewChild(SearchDistrictComponent) child!: SearchDistrictComponent;

    districtForm!: UntypedFormGroup;
    selectedDistrict: SchoolDistrict[] = [];
    selectedDistrictId: number[] = [];
    distLen: string = '';
    regionServiceLoaded$: Observable<boolean>;
    districts$: Observable<SchoolDistrict[]>;
    filteredDistricts: SchoolDistrict[] = [];
    regions: Region[] = [];
    allDistricts: SchoolDistrict[];
    isLoading: boolean = true;

    loaded$: Observable<boolean>;

    constructor(
        public dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private districtService: DistrictEntityService,
        private regionService: RegionEntityService,
        private helperService: HelperService,
        private cdr: ChangeDetectorRef
    ) {
        this.regionServiceLoaded$ = regionService.loaded$;
        this.districts$ = districtService.entities$;
        this.loaded$ = districtService.loaded$;
        this.districtForm = this.fb.group({
            districtSelect: ['']
        });

        this.loaded$?.subscribe((loaded) => {
            if (!loaded) {
                this.isLoading = true;
                this.districtSelect.disable();
            } else {
                this.isLoading = false;
                this.districtSelect.enable();
            }
        });

        this.subscribers();
    }

    ngOnInit(): void {
        /*
        this.cdr.detach();
        this.loaded$?.subscribe((x) => {
            if (!x) this.getDistricts();
        });
        
        const timeSpinnerOut = setTimeout(() => {
            this.isLoading = false;
        }, 7000); 
        // interval for doing the change detection every 5 seconds
        setInterval(() => {
          this.cdr.detectChanges();
        }, 1000);
		*/
    }

    ngOnChanges(): void {
        if (this.reset) {
            console.log('reset districts called');
            this.selectedDistrict = [];
        }
    }

    fnUpdateDistLen() {
        if (this.selectedDistrict) {
            this.distLen = this.selectedDistrict.length > 0 ? ':' + this.selectedDistrict?.length : '';
        } else {
            this.distLen = ':' + 0;
        }
    }

    getDistricts() {
        console.log('calling back getDistricts()');
        this.regionServiceLoaded$.subscribe((x) => {
            if (x) {
                this.allDistricts = [];
                this.districtService.getAll().subscribe((districts) => {
                    this.allDistricts = districts;
                    // console.log("allDistricts is showing:" + this.allDistricts)
                });
            }
        });
    }
    /*
    loadData() {
        console.log("now calling district loadData")
        this.loaded$.subscribe((x) => {
            if (x) {
                this.filteredDistricts = [];
                this.regions.forEach((reg) => {
                    this.allDistricts.forEach((element: District) => {
                        if (element.REGION.ORGANIZATIONS_ID === reg.ID) {
                            if (this.filteredDistricts.findIndex((x) => x.REGION == element.REGION) == -1) this.filteredDistricts.push(element);
                        }
                    });
                    this.filteredDistricts.sort((a, b) => parseInt(a.REGION.CODE) - parseInt(b.REGION.CODE));
                });
            }
        });
    }
*/

    setSelectedDistrict() {
        // set input regionid as selected
        if (this.DistrictCode) {
            this.selectedDistrictId.push(this.DistrictCode);
            console.log('district controller now setting value:' + this.DistrictCode);
            let districtShell: SchoolDistrict = new SchoolDistrict();

            districtShell.ID = this.DistrictCode;

            this.selectedDistrict.push(districtShell);
            this.districtForm.controls['districtSelect'].setValue(this.selectedDistrictId);
        }
    }

    fnOpenDialog(evt: MouseEvent) {
        if (this.districtSelect.disabled) return;

        const target = new ElementRef(evt.currentTarget);
        console.log('now calling opendialog with :' + this.selectedDistrict); // this.reset
        const dialogRef = this.dialog.open(SearchDistrictComponent, {
            width: '520px',
            height: '475px',
            data: { trigger: target, reset: this.reset, selectDistrict: this.selectedDistrictId }
        });

        dialogRef.afterClosed().subscribe((result) => {
            this.eventEmitterDistrictcode.emit(this.selectedDistrict);
            this.reset = false;
        });
    }

    subscribers() {
        this.helperService.selectedRegions$.subscribe((x: Region[]) => {
            if (x?.length <= 0) {
                this.helperService.lstUserProfileRegion$.subscribe((y: Region[]) => {
                    this.regions = y;
                });
            } else {
                this.regions = x;
            }
        });

        this.helperService.selectedDistrict$.subscribe((x) => {
            this.selectedDistrict = [];

            x.forEach((element) => {
                //console.log("subscribers method called:" + Object.entries(element))
                this.selectedDistrict.push(element);
            });
        });
    }

    get districtSelect(): any {
        return this.districtForm.get('districtSelect');
    }

    updateCounter(evt: Event) {
        console.log('update counter now:');
        console.log(evt);
    }
}
